import React, { Component } from 'react';

import { Layout } from 'antd';

import ChangePasswordForm from './ChangePasswordForm';

import './ChangePassword.css';

export default class ChangePassword extends Component {
  render() {
    return (
      <Layout className="ChangePassword">
        <Layout.Content className="ChangePasswordContent">
          <ChangePasswordForm />
        </Layout.Content>
      </Layout>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/App/ChangePassword/ChangePassword.js